import React, { useMemo } from 'react';
import { CCard, CCardBody, CCardHeader, CCol, CRow } from '@coreui/react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { reduce } from 'lodash';
import { selectInsightsData } from '../../../store/selectors/insights.selectors';
import { JobPhase } from '../../../shared/models/jobs';
import { WidgetName, WidgetType } from '../../../shared/models/insights';
import CardWidget from '../widgets/CardWidget';


const WIDGETS_CONFIG = [{
  key: 0,
  title: 'DELIVERIES COMPLETED',
  type: WidgetType.Value,
  field: WidgetName.Completed,
  completedTasksScreen: true,
},{
  key: 1,
  title: 'DELIVERIES CANCELED',
  type: WidgetType.Value,
  field: WidgetName.Canceled,
  completedTasksScreen: true,
},{
  key: 2,
  title: 'AVG FEEDBACK RATING',
  type: WidgetType.Rating,
  field: WidgetName.AvgRating,
  completedTasksScreen: true,
},{
  key: 3,
  title: '% ON TIME DELIVERIES',
  type: WidgetType.Percent,
  field: WidgetName.OnTimeDeliveries,
  completedTasksScreen: true,
}];

const SummarySection = () => {
  const history = useHistory();
  const data = useSelector(selectInsightsData);

  const computedData = useMemo(() => {
    const result = reduce(data?.tasks, (res, value) => {
      const isOnTime = value.time_arrived <= value.due_time;
      return {
        sum_rating: res.sum_rating + (+value.feedback_rating > 0 ? +value.feedback_rating : 0),
        count_rating: res.count_rating + (+value.feedback_rating > 0 ? 1 : 0),
        [WidgetName.Completed]: res[WidgetName.Completed] + ( value.last_phase === JobPhase.Completed ? 1 : 0),
        [WidgetName.Canceled]: res[WidgetName.Canceled] + ( value.last_phase === JobPhase.Cancelled ? 1 : 0),
        count_on_time_deliveries: res.count_on_time_deliveries + (isOnTime ? 1 : 0),
      };
    }, {
      sum_rating: 0,
      count_rating: 0,
      [WidgetName.Completed]: 0,
      [WidgetName.Canceled]: 0,
      count_on_time_deliveries: 0,
    });

    return {
      ...result,
      [WidgetName.AvgRating]: result.count_rating > 0 ? result.sum_rating / result.count_rating : 0,
      [WidgetName.OnTimeDeliveries]: data?.tasks?.length > 0 ? Math.round(result.count_on_time_deliveries * 100 / data?.tasks?.length) : 0
    }
  }, [data?.tasks]);

  const goCompletedScreen = (filterName) => {
    if (filterName) {
      history.push(`/insights/tasks/${filterName}`);
    }
  };

  return (
    <CRow>
      <CCol md={12}>
        <CCard className="glympser-container--roundedWithShadow">
          <CCardHeader className="border-0 glympser-roundedTop">
            Summary
          </CCardHeader>
          <CCardBody>
            <CRow>
              {
                WIDGETS_CONFIG.map((widget) => {
                  return (
                    <CCol key={widget.key} className="mb-3" md="4" sm="6" xl="3">
                      <CardWidget
                        widget={widget}
                        data={computedData[widget.field]}
                        clickHandler={goCompletedScreen}
                      />
                    </CCol>
                  )
                })
              }
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  )
};

export default SummarySection;
